const DEVICE_ID_KEY = 'pipeup_lightshow_deviceId';

let _id = null;

/**
 * Get or create a persistent device ID (localStorage-backed).
 * Shared across all modules so every request carries the same ID.
 */
export function getDeviceId() {
  if (_id) return _id;
  _id = localStorage.getItem(DEVICE_ID_KEY);
  if (!_id) {
    _id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, _id);
  }
  return _id;
}

/**
 * Fetch wrapper that adds X-Device-Id header to every request.
 * This enables device-based rate limiting on the server (instead of per-IP)
 * which prevents NAT/carrier-proxy collisions with 60k+ participants.
 */
export function apiFetch(url, options = {}) {
  const headers = { ...options.headers, 'X-Device-Id': getDeviceId() };
  return fetch(url, { ...options, headers });
}
